import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from './helpers/auth.guard';
import { FORM_ID } from './helpers/form-id.enum';
import { ShellComponent } from './shell/shell.component';

export const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: 'eciso',
        component: LayoutComponent,
        children: [
          {
            path: '',
            redirectTo: 'executive-dashboard',
            pathMatch: 'full',
          },
          {
            path: '',
            canActivate: [AuthGuard],
            loadChildren: () =>
              import('./features/admin/admin.module').then(
                (m) => m.AdminModule,
              ),
          },
        ],
      },
      { path: '', redirectTo: '/login', pathMatch: 'full' },
      {
        path: 'scc',
        loadChildren: () =>
          import('./apps/eciso/eciso.routes').then((m) => m.ECISO_ROUTES),
      },
      {
        path: 'dmarc',
        loadChildren: () =>
          import('./apps/edmarc/edmarc.routes').then((m) => m.EDMARC_ROUTES),
      },
      {
        path: 'easm',
        loadChildren: () =>
          import('./apps/easm/easm.routes').then((m) => m.EASM_ROUTES),
      },
      {
        path: 'emradar',
        loadChildren: () =>
          import('./apps/mradar/mradar.routes').then((m) => m.MRADAR_ROUTES),
      },
      {
        path: 'edai',
        loadChildren: () =>
          import('./apps/edai/edai.routes').then((m) => m.EDAI_ROUTES),
      },
      {
        path: 'erisk',
        loadChildren: () =>
          import('./apps/erisk/erisk.routes').then((m) => m.ERISK_ROUTES),
      },
      {
        path: 'escr',
        loadChildren: () =>
          import('./apps/esca/esca.routes').then((m) => m.ESCA_ROUTES),
      },
      {
        path: 'ecompliance',
        loadChildren: () =>
          import('./apps/ecompliance/ecompliance.routes').then(
            (m) => m.ECOMPLIANCE_ROUTES,
          ),
      },
      {
        path: 'app/:appId',
        loadComponent: () =>
          import('./external-app/external-app.component').then(
            (m) => m.ExternalAppComponent,
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
      },
      {
        path: 'evm',
        loadChildren: () =>
          import('./apps/evm/evm.routes').then((m) => m.EVM_ROUTES),
      },
    ],
  },
  {
    path: 'form/:formId',
    loadComponent: () =>
      import('./features/renderer/renderer.component').then(
        (m) => m.RendererComponent,
      ),
  },
  {
    path: 'form/:formId/:recordId',
    loadComponent: () =>
      import('./features/renderer/renderer.component').then(
        (m) => m.RendererComponent,
      ),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/login/login.component').then(
        (m) => m.LoginComponent,
      ),
    data: { workflowId: FORM_ID.LOGIN_WORKFLOW },
  },
  {
    path: 'workflow/:wId',
    loadComponent: () =>
      import('./features/workflow-renderer/workflow-renderer.component').then(
        (m) => m.WorkflowRendererComponent,
      ),
  },
  {
    path: 'workflow/:wId/:nodeId',
    loadComponent: () =>
      import('./features/workflow-renderer/workflow-renderer.component').then(
        (m) => m.WorkflowRendererComponent,
      ),
  },
  {
    path: 'workflow/:wId/:nodeId/:recordId',
    loadComponent: () =>
      import('./features/workflow-renderer/workflow-renderer.component').then(
        (m) => m.WorkflowRendererComponent,
      ),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./features/error-handler/error-handler.module').then(
        (m) => m.ErrorHandlerModule,
      ),
  },
  {
    path: 'graph-lab',
    loadComponent: () =>
      import('./features/graph-lab/graph-lab.component').then(
        (m) => m.GraphLabComponent,
      ),
  },
  // {
  //   path: '**',
  //   redirectTo: 'error/unauthorized',
  // },
];
